<template>
  <div>
    <div class="container">
      <h2 class="font-weight-bold font-size-medium text-center">Trocar senha</h2>
      <p class="text-center">Escolha uma nova senha</p>

      <div class="col-md-6 mx-md-auto">
        <form
          class="default-form my-5"
          action=""
          method="POST"
          @submit.prevent="submit"
        >
          <DefaultInput
            type="email"
            label="Endereço de email"
            v-model="$v.form.email.$model"
          />

          <div class="form-group default-input">
            <i class="fa field-icon" :class="[pwdIcon]" @click="hidePwd = !hidePwd"></i>
            <input :type="pwdFT" class="form-control with-label" v-model="$v.form.password.$model" placeholder="" />
            <label>Senha</label>
          </div>

          <div class="form-group default-input">
            <i class="fa field-icon" :class="[pwdConfirmIcon]" @click="hideCPwd = !hideCPwd"></i>
            <input :type="cpwdFT" class="form-control with-label" v-model="$v.form.password_confirmation.$model" placeholder="" />
            <label>Confirme sua senha</label>
          </div>

          <div class="text-center mt-5">
            <Button
              class="btn-primary btn-lg"
              :loading="loader"
              :disabled="$v.$invalid"
              @click="submit"
            >
              Trocar senha
            </Button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { required, email } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'
import DefaultInput from '@/components/common/Input/DefaultInput.vue'

export default {
  components: {
    Button,
    DefaultInput
  },
  data () {
    return {
      hidePwd: true,
      hideCPwd: true,
      form: {
        email: '',
        password: '',
        password_confirmation: '',
        token: this.$route.params.token
      },
      loader: false
    }
  },
  metaInfo () {
    return {
      title: 'Trocar senha'
    }
  },
  validations () {
    return {
      form: {
        email: { required, email },
        password: { required },
        password_confirmation: { required },
        token: { required }
      }
    }
  },
  computed: {
    pwdFT () {
      return this.hidePwd ? 'password' : 'text'
    },
    pwdIcon () {
      return this.hidePwd ? 'fa-eye' : 'fa-eye-slash'
    },
    cpwdFT () {
      return this.hideCPwd ? 'password' : 'text'
    },
    pwdConfirmIcon () {
      return this.hideCPwd ? 'fa-eye' : 'fa-eye-slash'
    },
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  },
  methods: {
    async submit () {
      this.loader = true
      try {
        await AuthService.sendResetPassword(this.form)
        const notification = {
          notification: {
            type: 'success',
            content: 'Senha alterada com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$router.push('/')
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
